export interface HconDialogOption {
    id: string,
    type?: 'dialog' | 'inProgress',
    modal?: boolean,
    message?: Ref<string>,
    closeable: boolean,
    buttons?: string[],
    callback?: (buttonIndex: number | null) => void,
    origin: string | null,
}

const   dialogs:Ref<HconDialogOption[]> | undefined    = import.meta.client ? ref([]) : undefined;
let     alertIdIndex    = 0;

export const useHconDialog = () => {
    const route     = useRoute();
    const device    = useDevice();
    return {
        inProgress: (isModal?: boolean) => {
            if (dialogs) {
                const dialogId  = 'dialog' + (++alertIdIndex);
                dialogs.value.push({
                    id: dialogId,
                    type: 'inProgress',
                    modal: isModal,
                    closeable: false,
                    origin: route.path,
                });
                return dialogId;
            }
        },
        dimm: (message?: string | Ref<string>) => {
            if (dialogs) {
                const dialogId  = 'dialog' + (++alertIdIndex);
                dialogs.value.push({
                    id: dialogId,
                    message: message ? toRef(message) : undefined,
                    closeable: false,
                    origin: route.path,
                });
                return dialogId;
            }
        },
        alert:   (message: string | Ref<string>, onclose?: () => void) => {
            if (dialogs) {
                const dialogId  = 'dialog' + (++alertIdIndex);
                dialogs.value.push({
                    id: dialogId,
                    message: toRef(message),
                    closeable: false,
                    buttons: ['확인'],
                    callback: () => {
                        if (onclose) {
                            onclose();
                        }
                        dialogs.value = dialogs.value.filter(dialog => dialog.id != dialogId);
                    },
                    origin: route.path,
                });
                return dialogId;
            }
        },
        confirm: (message: Ref<string> | string, onchoice: (choose: boolean | null) => void) => {
            if (dialogs) {
                const dialogId  = 'dialog' + (++alertIdIndex);
                dialogs.value.push({
                    id: dialogId,
                    message: toRef(message),
                    closeable: false,
                    buttons: device.isMobile ? ['아니오', '예'] : ['예', '아니오'],
                    callback: (bidx) => {
                        onchoice(bidx == null ? null : device.isMobile ? bidx == 1 : bidx == 0);
                        dialogs.value = dialogs.value.filter(dialog => dialog.id != dialogId);
                    },
                    origin: route.path,
                });
                return dialogId;
            }
        },
        choice: (message: Ref<string> | string, buttons: string[], onchoice: (choose: number | null) => void, closeWhenChoose?: boolean, closeable?: boolean) => {
            if (dialogs) {
                const dialogId  = 'dialog' + (++alertIdIndex);
                dialogs.value.push({
                    id: dialogId,
                    message: toRef(message),
                    buttons: device.isMobile ? buttons.reverse() : buttons,
                    closeable: closeable != false,
                    callback: (bidx) => {
                        onchoice(bidx == null ? null : device.isMobile ? buttons.length - bidx - 1 : bidx);
                        if (closeWhenChoose != false) {
                            dialogs.value = dialogs.value.filter(dialog => dialog.id != dialogId);
                        }
                    },
                    origin: route.path,
                });
                return dialogId;
            }
        },
        close: (dialogId?: string) => {
            if (dialogs && dialogId != undefined) {
                const targetDialog = dialogs.value.find(dialog => dialog.id == dialogId);
                if (targetDialog?.callback) {
                    targetDialog.callback(null);
                }
                dialogs.value   = dialogs.value.filter(dialog => dialog != targetDialog);
            }
        },
        immortalize: (dialogId?: string) => {
            if (dialogs && dialogId != undefined) {
                const targetDialog = dialogs.value.find(dialog => dialog.id == dialogId);
                if (targetDialog) {
                    targetDialog.origin = null;
                }
            }

        },
        watch:  (handler: (dialogs: HconDialogOption[]) => void) => {
            if (dialogs) {
                watchEffect(() => {
                    const currentPath   = route.path;
                    dialogs.value       = dialogs.value.filter(dialog => dialog.origin == currentPath || dialog.origin == null);
                });
                watchEffect(() => {
                    handler([...dialogs.value])
                });
            }
        },
    }
}
